(function() {

    'use strict';

    angular.module('Services').factory('scrollToForm', scrollToForm);

    function scrollToForm() {
        return function (formName) {
            $('html, body').animate({
                scrollTop: $('form[name="' + formName + '"]').offset().top - '70'
            }, 500);
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/Factories/scrollTo.js